import { useState } from "react";
import UserTable from "../components/usertable";

const Users = () => {
  const tabs = [
    "student",
    "startup",
    "investor",
    "freelancer",
    "mentor",
    "hr",
    "legal",
    "incubationcenter",
  ];

  const [activeTab, setActiveTab] = useState("student");

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-2">User Management</h2>

      {/* Tabs */}
      <div className="flex gap-4 border-b mb-4">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-2 border-b-2 capitalize ${
              activeTab === tab
                ? "border-blue-500 text-blue-600 font-medium"
                : "border-transparent hover:border-blue-300"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <UserTable activeRole={activeTab} />
    </div>
  );
};

export default Users;
